const l = e => e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase(),
  t = (e, r) => e.filter(a => l(a.label).includes(l(r)));
export { t as handleFilteredItems, l as normalizeSearchString };